import { gql } from '@apollo/client';

export const UPLOAD_CERTIFICATE = gql`
  mutation UploadCertificate($dataProducerName: String!, $file: String!, $projectId: String!, $vendorId: String!) {
    uploadCertificate(dataProducerName: $dataProducerName, file: $file, projectId: $projectId, vendorId: $vendorId) {
      status
    }
  }
`;
